export interface InGridConfig {
  type: string
  position: number
  columnSpan: 1 | 2 | 4
  mediaType: "image" | "video"
  desktopImage: string
  mobileImage: string
  videoSource: "shopify" | "youtube" | "vimeo"
  videoFile: string
  videoUrl: string
  imageLink: string
  eyebrow: string
  heading: string
  ctaText: string
  ctaUrl: string
  ctaText2: string
  ctaUrl2: string
}

const VALID_COLUMN_SPANS = new Set([1, 2, 4])

function isValidConfig(item: unknown): item is InGridConfig {
  if (typeof item !== "object" || item === null) return false
  const obj = item as Record<string, unknown>
  return (
    typeof obj.type === "string" &&
    typeof obj.position === "number" &&
    obj.position >= 1 &&
    VALID_COLUMN_SPANS.has(obj.columnSpan as number)
  )
}

let cachedConfig: InGridConfig[] | null = null

export function readInGridConfig(): InGridConfig[] {
  if (cachedConfig !== null) return cachedConfig

  const el = document.getElementById("nosto-ingrid-config")
  if (!el?.textContent) {
    cachedConfig = []
    return cachedConfig
  }

  try {
    const parsed: unknown = JSON.parse(el.textContent)
    if (!Array.isArray(parsed)) {
      cachedConfig = []
      return cachedConfig
    }
    cachedConfig = parsed.filter(isValidConfig).sort((a, b) => a.position - b.position)
  } catch {
    cachedConfig = []
  }

  return cachedConfig
}
